import { useEffect, useState } from "react";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
export var usePlanData = function () {
    var _a;
    var plan = useState(findParamInLocalStorage("Plan"))[0];
    var productCode = useState((_a = findParamInLocalStorage("productCode", "steps")) !== null && _a !== void 0 ? _a : "")[0];
    var _b = useState(""), planCode = _b[0], setPlanCode = _b[1];
    useEffect(function () {
        var _a;
        if (plan) {
            setPlanCode((_a = plan[0].code) !== null && _a !== void 0 ? _a : "");
        }
    }, [plan]);
    return {
        productCode: productCode,
        planCode: planCode,
    };
};
